(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairSideEventsController', PhysicalFairSideEventsController);
    PhysicalFairSideEventsController.$inject = ['ExpoService', 'PhysicalFairService'];
    function PhysicalFairSideEventsController(ExpoService, PhysicalFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.selectExpo            = selectExpo;
        vm.selectCities          = selectCities;
        vm.getByFilter           = getByFilter;
        vm.sideEvents            = [
            {id : 'matchmaking_session', name : 'Business-to-business'},
            {id : 'market_briefing', name : 'Market Briefing'},
            {id : 'networking_reception', name : 'Networking Reception'},
            {id : 'networking_event', name : 'Networking Event'},
            {id : 'presentation_local_university', name : 'Presentation at Local University'}
        ];
        vm.sideEventsSelected   = [];

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function selectCities () {
            vm.query = {};
            vm.query['expos_ids'] = vm.expoSelected;
            ExpoService.getExposCities(vm.query).then(function(response){
                vm.cities = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {

            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            if(vm.expoSelected !== '') {
                vm.query['expo_id'] = vm.expoSelected;
            }
            if(vm.citySelected !== '') {
                vm.query['expo_location_id'] = vm.citySelected;
            }
            if(vm.sideEventsSelected.length > 0) {
                vm.query['side_events'] = JSON.stringify(vm.sideEventsSelected);
            }

            console.log(vm.query);
            PhysicalFairService.getSideEvents(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.exhibitors       = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err){
            });
        }
        activate();
    }
})();